export class VisorResponse {
    httpStatus : number;
    response : {
      id : string,
      codeResponse :  string,
      response : string,
      list : [
        {
           autores : [
            {
               alternativo :  string ,
               apellidoP :  string ,
               appelidoM :  string ,
               id_autor :  string ,
               nombre :  string 
            }
          ],
          tema:[
              {
                  id_tema:string,
                  tema:string
              }
          ],
          licencia:[{
              id_licencia:string,
              nombre_largo:string,
              nombre_corto:string,
              nombre_imagen:string,
              despcrion:string
          }],
          id_documental :  string ,
          titulo :  string ,
          tipo :  string ,
          urlBasic :  string ,
          directorio :  string ,
          url :  string ,
          descripcion :  string ,
          nota :  string ,
          fechaPublicacion :  string ,
          idLicencia :  string ,
          idFormatoM :  string ,
          idDescripFormatoM : string,
          idFormato : string,
          perfil : string,
          flagDownload: string,
          flagTranscripcion:string,
        }
      ]
    }
    constructor(){
        this.httpStatus = 0;
        this.response = {
        id : "",
        codeResponse :  "",
        response : "",
        list : [
            {
            autores : [
                {
                alternativo :  "" ,
                apellidoP :  "" ,
                appelidoM :  "" ,
                id_autor :  "" ,
                nombre :  ""
                }
            ],
            tema:[
                {
                    id_tema:"",
                    tema:""
                }
            ],
            licencia:[{
                id_licencia:"",
                nombre_largo:"",
                nombre_corto:"",
                nombre_imagen:"",
                despcrion:""
            }],
            id_documental :  "" ,
            titulo :  "" ,
            tipo :  "" ,
            urlBasic :  "" ,
            directorio :  "" ,
            url :  "" ,
            descripcion :  "" ,
            nota :  "" ,
            fechaPublicacion :  "" ,
            idLicencia :  "" ,
            idFormatoM :  "" ,
            idDescripFormatoM : "",
            idFormato : "",
            perfil: "",
            flagDownload: "",
            flagTranscripcion:"",
            }
        ]
        }
    }
}
